// depends on Perspective3.Core.DataEnums.CoverageType - api enum

export enum CoverageType {
  medical = 1,
  pharmacy = 2,
}
